import {
  createContext,
  useContext,
  useMemo,
  type PropsWithChildren,
} from "react";

interface SettingsContextType {
  preferBrowserSentiment: boolean;
  setPreferBrowserSentiment: (value: boolean) => void;
  togglePreferBrowserSentiment: () => void;
}

const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined
);

function SettingsProvider({ children }: PropsWithChildren) {
  const value = useMemo(
    () => ({
      preferBrowserSentiment: true,
      setPreferBrowserSentiment: () => {},
      togglePreferBrowserSentiment: () => {},
    }),
    []
  );

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
}

function useSettingsContext() {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error(
      "useSettingsContext must be used within a SettingsProvider"
    );
  }
  return context;
}

// eslint-disable-next-line react-refresh/only-export-components
export { SettingsProvider, useSettingsContext };
